import React, { ReactNode } from 'react';

type Props = {
  isOpened: boolean,
  toggle: () => void,
  buttonRef: HTMLButtonElement,
  children: ReactNode
  className?: string
};

class CloseableComponent extends React.PureComponent<Props> {
  ref: HTMLDivElement;

  handleClickOutside = (e: MouseEvent):void => {
    e.stopPropagation();
    if (this.props.isOpened
      && this.ref
      && !this.ref.contains(e.target as Node)
      && (!this.props.buttonRef
        || (this.props.buttonRef && !this.props.buttonRef.contains(e.target as Node)))
    ) {
      this.props.toggle();
    }
  };

  handleKeyDown = (e: KeyboardEvent):void => {
    e.stopPropagation();
    if (this.props.isOpened && e.which === 27) {
      this.props.toggle();
    }
  };

  componentDidMount():void {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('touchstart', this.handleClickOutside);
    document.addEventListener('keydown', (e) => {
      if (e.which === 27) {
        this.handleKeyDown(e);
      }
    });
  }

  componentWillUnmount():void {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('touchstart', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  render():ReactNode {
    return (
      <div
        className={`closeable-component${this.props.isOpened ? ' open' : ''} ${this.props.className}`}
        ref={(ref: HTMLDivElement) => {
          this.ref = ref;
        }}
      >
        {this.props.children}
      </div>
    );
  }
}

export default CloseableComponent;
